import {buildUrl} from '../Data/Http'
import {DeliveryAddress} from '../Entities/DeliveryAddress'
import {InvoiceAddress} from '../Entities/InvoiceAddress'
import {OrderCreateWithDetails} from '../Entities/OrderCreateWithDetails'
import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'
import {OrderGeneralInformation} from '../Entities/OrderGeneralInformation'
import {OrderPaid} from '../Entities/OrderPaid'
import * as SerializedOrderFilter from '../Data/SerializedOrderFilters'
import * as OffsetLimit from '../Data/OffsetLimit'

export function create(
    manufacturerId: number,
    orderCreateWithDetails: OrderCreateWithDetails,
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/manufacturers/${manufacturerId}/orders`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(orderCreateWithDetails),
    }
}

export function patchDeliveryAddress(
    deliveryInformation: DeliveryAddress,
    id: number,
): HttpRequest {
    return {
        verb: 'PATCH',
        url: `${server}/orders/${id}`,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(deliveryInformation),
    }
}

export function patchGeneralInformation(
    orderDetails: OrderGeneralInformation,
    id: number,
): HttpRequest {
    return {
        verb: 'PATCH',
        url: `${server}/orders/${id}`,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderDetails),
    }
}

export function patchInvoiceAddress(
    invoiceAddress: InvoiceAddress,
    id: number,
): HttpRequest {
    return {
        verb: 'PATCH',
        url: `${server}/orders/${id}`,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(invoiceAddress),
    }
}

export function patchOrderPaid(
    orderPaid: OrderPaid,
    id: number,
): HttpRequest {
    return {
        verb: 'PATCH',
        url: `${server}/orders/${id}`,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({orderPaid}),
    }
}

export function listWithOwnersAndPositions(
    manufacturerId: number,
    filters: SerializedOrderFilter.SerializedOrderFilter[],
    offsetLimit: OffsetLimit.OffsetLimit,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/orders-with-owners-and-positions`,
                {
                    ...OffsetLimit.toQueryParameters(offsetLimit),
                    ...SerializedOrderFilter.toQueryParameters(filters),
                },
            ),
        headers: {
            'Accept': 'application/json',
        },
    }
}

export function listWithOwners(
    manufacturerId: number,
    filters: SerializedOrderFilter.SerializedOrderFilter[],
    offsetLimit: OffsetLimit.OffsetLimit,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/orders-with-owners`,
                {
                    ...OffsetLimit.toQueryParameters(offsetLimit),
                    ...SerializedOrderFilter.toQueryParameters(filters),
                },
            ),
        headers: {
            'Accept': 'application/json',
        },
    }
}

export function retrieveWithDetails(
    manufacturerId: number,
    orderNumber: string,
): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/manufacturers/${manufacturerId}/orders-with-details/${orderNumber}`,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/OrderResource.ts